import { Alert, Button } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { FloatingLabel, Form } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Auth from "../services/context/store";
import LoadingIcon from "../components/LoadingIcon";

function NewPassword() {
  const location = useLocation();
  const token = location.search.slice(3, location.search.length);

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [notificationType, setNotificationType] = useState("");
  const [passwords, setPasswords] = useState({
    newPassword: "",
    reEnterNewPassword: "",
  });
  const [state] = useContext(Auth);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setPasswords((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
 
    if (passwords.newPassword.length < 8) {
      setNotificationType("error");
      setMessage("Password must be 8 characters long");
      setLoading(false);
      return;
    }

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}new/user/password/${token}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          newPassword: passwords.newPassword,
        }),
      }
    );

    const data = await response.json();
    if (data.status) {
      setNotificationType("success");
      setPasswords({
        newPassword: "",
        reEnterNewPassword: "",
      });
      setTimeout(() => {
        navigate("/login");
      }, 3000);
    } else {
      setNotificationType("error");
    }
    setMessage(data.message);
    setLoading(false);
  };
  useEffect(() => {
    if (state.loggedIn) {
      navigate("/account/overview");
    }
  }, [navigate, state.loggedIn]);
  return (
     <div className="auth-screen">
      <div className="md:w-1/2 mx-auto">
        <div className="d-flex mb-10 mt-10 p-2">
          <div
            className="w-full bg-white rounded-sm p-3"
            style={{ textAlign: "center", height: "450px" }}
          >
            <Form onSubmit={handleSubmit}>
              <div className="row">
                <div className="p-4" style={{ height: "450px" }}>
                  <div className="text-center mb-8 text-2xl">
                    Enter Your New{" "}
                    <span className="text-blue-600">Password</span>{" "}
                  </div>
                  <FloatingLabel label="Enter new password" className="mb-4">
                    <Form.Control
                      onChange={handleChange}
                      type="password"
                      name="newPassword"
                      placeholder="name@example.com"
                      required
                      disabled={loading}
                    />
                  </FloatingLabel>

                  <FloatingLabel label="Confirm new password" className="mb-4">
                    <Form.Control
                      onChange={handleChange}
                      type="password"
                      name="reEnterNewPassword"
                      placeholder="name@example.com"
                      required
                      disabled={loading}
                    />
                  </FloatingLabel>
                  <div className="d-grid gap-2 my-8">
                    {loading ? (
                      <Button size="large">
                        <LoadingIcon />
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        size="large"
                        type="submit"
                        disabled={
                          passwords.newPassword === passwords.reEnterNewPassword
                            ? false
                            : true
                        }
                      >
                        Reset Password
                      </Button>
                    )}
                  </div>
                  {message && (
                    <Alert sx={{ mt: 2 }} severity={notificationType}>
                      {message}
                    </Alert>
                  )}
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewPassword;
